import 'date-fns';

const debounce = (func, wait = 180) => {
    let timeout;
    let clicks = 0;
    return (args = {}) => {
        const later = function () {
            func(args, clicks);
            clearTimeout(timeout);
            timeout = null;
            clicks = 0;
        };
        clicks += 1;
        if (!timeout) {
            timeout = setTimeout(later, wait);
        }
    };
};

export { debounce };
//# sourceMappingURL=functions.js.map
